import { formatDate } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileType, PotentialPlaceholder } from '@schir-int-client/binary-shared';

export interface ChangeFileSuccessDialogData {
	fileType: FileType;
	file: File;
	report?: PotentialPlaceholder[];
}

@Component({
	selector: 'schir-int-client-change-file-success-dialog',
	templateUrl: './change-file-success-dialog.component.html',
	styleUrls: ['./change-file-success-dialog.component.scss'],
	standalone: false,
})
export class ChangeFileSuccessDialogComponent {
	readonly report: PotentialPlaceholder[];
	readonly type: FileType;

	constructor(@Inject(MAT_DIALOG_DATA) public data: ChangeFileSuccessDialogData) {
		this.report = data.report ?? [];
	}

	get fileName(): string {
		return this.data.file.name;
	}

	get lastModifiedDate(): string {
		return formatDate(new Date(this.data.file.lastModified), 'dd. MM. yyyy, HH:mm', 'de');
	}

	get verdict(): string[] {
		if (this.report.length === 0) {
			return ['Die Datei enthält keine erkannten Platzhalter. Prüfen Sie, ob die Datei ersetzt werden sollte.'];
		}

		const deprecatedCount = this.report.filter(row => row.isDeprecated).length;
		const resolveInVorlageCount = this.report.filter(
			row => row.isPlatzhalter && !row.isReplacedInKorrespondenz
		).length;
		const nonPlaceholderCount = this.report.filter(row => !row.isPlatzhalter).length;
		let issueCount = deprecatedCount + nonPlaceholderCount;
		if (this.type === FileType.KORRESPONDENZ) issueCount += resolveInVorlageCount;

		if (issueCount === 0) {
			return [`Die vorhanden ${this.report.length} Platzhalter können problemlos verarbeitet werden.`];
		}
		const result = [];
		if (deprecatedCount > 0) {
			result.push(
				deprecatedCount +
					' Platzhalter sind veraltet. Es wird empfohlen, diese durch die jeweilige neuere Version zu ersetzten.'
			);
		}
		if (nonPlaceholderCount > 0) {
			result.push(
				nonPlaceholderCount +
					' Ausdrücke wurden nicht als Platzhalter erkannt. Prüfen Sie diese und korrigieren Sie ggf. das Dokument.'
			);
		}
		if (this.data.fileType === FileType.KORRESPONDENZ && resolveInVorlageCount > 0) {
			result.push(
				resolveInVorlageCount +
					' Platzhalter hätten bereits in der Vorlage ersetzt werden sollen. ' +
					'Sie werden bei Erstellung der Korrespondenz nicht mehr ersetzt.'
			);
		}

		return result;
	}

	formatBoolean(value: boolean): string {
		return value ? 'Ja' : 'Nein';
	}
}
